module.exports = __webpack_public_path__ + "static/media/Stonk.02788ded.png";